<header>

 
        <img src="/img/poll_ninja_logo.svg" alt="Ninja Img">


</header>




<style>
    header{
        background-color: #f7f7f7;
    }
    img{
        max-width: 200px;
        display: block;
        margin: 0 auto;
        padding: 10px 0;
    }
</style>